import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCreditcardAlt = function SvgCreditcardAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M17.96 10.5a2.016 2.016 0 100-4.031 2.016 2.016 0 000 4.031z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M19.93 2.531H4.023A3.981 3.981 0 00.04 6.516v10.968a3.981 3.981 0 003.984 3.985h15.954a3.981 3.981 0 003.984-3.985V6.516c0-2.204-1.828-3.985-4.031-3.985zM4.023 4.5h15.954c1.078 0 2.015.89 2.015 2.016V13.5H2.008V6.516A2 2 0 014.023 4.5zM19.93 19.453H4.023c-1.078 0-2.015-.89-2.015-2.015h19.937a2 2 0 01-2.015 2.015z"
  }));
};

export default SvgCreditcardAlt;